import React from 'react';
import { AdminBox } from 'utils/Stylesheet/style.js';
import PropTypes from 'prop-types';
import './style.scss';

const Index = ({ data, title }) => {
    const handleConditionalrendering = () => {
        if (title === 'admin') {
            return (
                <>
                    <img className='avatar-24' src={data.pictureURL} alt='img' />
                    <span>{data.name}</span>
                </>
            );
        } else {
            return <span className='channel'>#{data?.name}</span>;
        }
    };
    return (
        <div>
            <AdminBox className='channel-box'>{handleConditionalrendering()}</AdminBox>
        </div>
    );
};
Index.propTypes = {
    data: PropTypes.object,
    title: PropTypes.string,
};

export default Index;
